'use strict';

import register from './core';
import '../functions/jquery-global';
import Handlebars from 'handlebars/dist/handlebars';
import Fuse from 'fuse.js/dist/fuse';
import ClipboardJS from 'clipboard/dist/clipboard';

register('search-generator', function (element) {

  Handlebars.registerHelper('isnull', function (value) {
    return value === null;
  });

  Handlebars.registerHelper('if_eq', function (a, b) {
    return a === b;
  });

  Handlebars.registerHelper('show_tag_type', function (value) {
    return value === 'sv' || value === 'en' ? 'Public tag' : 'Tags';
  });

  let template = Handlebars.compile($("#template-main").html()),
    $document = $(document),
    $dropdownCheckbox = $('.dropdown-checkbox'),
    $queryString = $('#query-string'),
    $listLanguages = $('#list-languages'),
    $listSites = $('#list-sites'),
    hiddenClassName = 'visually-hidden',
    checkedClassName = 'dropdown-checkbox__list-item--checkbox-checked',
    activeClassName = 'dropdown-checkbox__toggle--active',
    currentConfigButtonDataId = 'currentConfig',
    $searchConfigActive = $('#search-config-active'),
    $searchConfigContainer = $('#search-config-container'),
    $tagsWrapper = $('#tags-wrapper'),
    currentConfigButtonSelector = `[data-id="${currentConfigButtonDataId}"]`,
    siteIdAttr = 'data-siteid',
    siteLanguageAttr = 'data-language',
    $siteId = $(`[${siteIdAttr}]`, $searchConfigActive),
    $siteLanguage = $(`[${siteLanguageAttr}]`, $searchConfigActive),
    searchConfigTemplate = Handlebars.compile($("#template-searchConfig").html()),
    languagesTemplate = $('#template-languages').html(),
    sitesTemplate = $('#template-sites').html(),
    $listOrganisations = $('#list-organisations'),
    $listCategories = $('#list-categories'),
    $searchTagsFilter = $('#search-tags-filter'),
    $listTagsFilter = $('#list-tags-filter'),
    $listTags = $('#list-tags'),
    templateTags = Handlebars.compile($("#template-tags").html()),
    templateTagsFilter = Handlebars.compile($("#template-tags-filter").html()),
    templateResultDefault = Handlebars.compile($("#template-result-default").html()),
    $getResultButton = $('#get-result-button'),
    $searchQuery = $('#search-query'),
    $searchConfigApply = $('#search-config-apply'),
    $searchResult = $('#search-result'),
    specialFilterTemplate = $('#template-specialfilter').html(),
    checkboxListTemplate = $('#template-checkbox-list').html(),
    $listIsScientist = $('#list-isscientist'),
    $listIsLocal = $('#list-islocal'),
    $listProjectPageDates = $('#list-projectpage-dates'),
    $listIsDoctoralProject = $('#list-isdoctoral-project'),
    $listEduLevel = $('#list-edu-level'),
    $listEduTempo = $('#list-edu-tempo'),
    $listEduLimitations = $('#list-edu-limitations'),
    sortingTemplate = $('#template-sorting').html(),
    $listSorting = $('#list-sorting'),
    fuse;

  var getCurrentValues = function () {
    var organisationValues = $('input[name="organisationFilters"]:checked', $listOrganisations)
      .map(function () { return this.value; }).get();

    var categoryValues = $('input[name="categoryFilters"]:checked', $listCategories)
      .map(function () { return this.value; }).get();

    var tagsValues = $(`li:not(.${hiddenClassName}) input[name="tagFilters"]`, $listTags)
      .map(function () { return this.value; }).get();

    var isScientistValue = $('input[name="isscientist"]:checked', $listIsScientist);
    var isLocalValue = $('input[name="islocal"]:checked', $listIsLocal);
    var projectPageDatesValue = $('input[name="projectpagedates"]:checked', $listProjectPageDates);
    var isDoctoralProjectValue = $('input[name="isdoctoralproject"]:checked', $listIsDoctoralProject);
    var eduLevelValue = $('input[name="edulevel"]:checked', $listEduLevel);
    var eduTempoValue = $('input[name="edutempo"]:checked', $listEduTempo);

    var limitationValues = $('input[name="eduLimitations"]:checked', $listEduLimitations)
      .map(function () { return this.value; }).get();

    return {
      'site': { 'name': $siteId.text(), 'value': $siteId.attr(siteIdAttr) },
      'language': { 'name': $siteLanguage.text(), 'value': $siteLanguage.attr(siteLanguageAttr) },
      'organisations': { 'value': organisationValues },
      'categories': { 'value': categoryValues },
      'tags': { 'value': tagsValues },
      'isLocal': { 'value': isLocalValue.attr('data-value') },
      'isScientist': { 'value': isScientistValue.attr('data-value') },
      'projectPageDates': { 'value': projectPageDatesValue.attr('data-value') },
      'isDoctoralProject': { 'value': isDoctoralProjectValue.attr('data-value') },
      'eduLevel': { 'value': eduLevelValue.attr('data-value') },
      'eduTempo': { 'value': eduTempoValue.attr('data-value') },
      'eduLimitations': { 'value': limitationValues }
    };
  };

  var updateCurrentValues = function () {
    var currentValues = getCurrentValues();
    var currentConfigObject = searchConfigTemplate({ Id: currentConfigButtonDataId, Data: currentValues });
    $(currentConfigButtonSelector, $searchConfigContainer).replaceWith(currentConfigObject);
    currentValues.tags.value.length > 0 ? $tagsWrapper.show() : $tagsWrapper.hide();
  };

  var resetCurrentFilters = function () {
    $listOrganisations.html('');
    $listCategories.html('');
    $listTags.html('');
    $listTagsFilter.html('');
    $listIsScientist.html('');
    $listIsLocal.html('');
    $listProjectPageDates.html('');
    $listIsDoctoralProject.html('');
    $listEduLevel.html('');
    $listEduTempo.html('');
    $listEduLimitations.html('');
    fuse = null;
    $siteId.attr(siteIdAttr, '').text('');
    $siteLanguage.attr(siteLanguageAttr, '').text('');
    updateCurrentValues();
    $(currentConfigButtonSelector, $searchConfigContainer).text('...');
    $searchConfigApply.attr('disabled', '');
  };

  // setup initial stuff, load languages and sites
  var init = function () {
    Handlebars.registerPartial("list", $("#template-list").html());

    $.ajax({
      url: '/api/SearchGeneratorCommon/languages'
    }).done(function (data) {
      let template = Handlebars.compile(languagesTemplate);
      $listLanguages.html(template({ Data: data, Name: 'languages' }));
    });

    $.ajax({
      url: '/api/SearchGeneratorCommon/SiteFilters'
    }).done(function (data) {
      let template = Handlebars.compile(sitesTemplate);
      $listSites.html(template({ Data: data, Name: 'sites' }));
    });

    new ClipboardJS('.button__copy');

    $queryString.on('focus', function () {
      this.select();
    });

    $searchResult.html(templateResultDefault());  

    $.ajax({
      url: '/api/SearchGeneratorCommon/sortings'
    }).done(function (data) {
      let template = Handlebars.compile(sortingTemplate);
      $listSorting.html(template({ Data: data, Name: 'sorting' }));
    });

    resetCurrentFilters();
  };

  init();

  $('#search-config-special').click(function () {
    var $this = $(this);
    var $filters = $this.siblings('div:first');
    $this.text($this.attr($filters.is(':hidden') ? 'data-visible-text' : 'data-hidden-text'));
    $filters.toggle();
  }).trigger('click');

  $('#search-config-add').click(function () {
    var $site = $('input[name="sites"]:checked', $listSites);
    var $language = $('input[name="languages"]:checked', $listLanguages);

    if ($site.length === 0 || $language.length === 0)
      return;

    resetCurrentFilters();

    var siteId = $site.attr('data-value');
    var siteName = $site.attr('data-text');
    var siteLang = $language.attr('data-value');
    var siteLangName = $language.attr('data-text');
    var headers = { 'X-Language': siteLang };
    $siteId.attr(siteIdAttr, siteId).text(siteName);
    $siteLanguage.attr(siteLanguageAttr, siteLang).text(siteLangName);
    
    $.ajax({
      url: `/api/SearchGeneratorCommon/OrganisationFilters?siteId=${siteId}`,
      headers: headers
    }).done(function (data) {
        $listOrganisations.html(template({ Name: 'organisationFilters', Children: data }));
    });

    $.ajax({
      url: `/api/SearchGeneratorCommon/CategoryFilters?siteId=${siteId}`,
      headers: headers
    }).done(function (data) {
      $listCategories.html(template({ Name: 'categoryFilters', Children: data, UseIsSelected: true }));
    });

    $.ajax({
      url: '/api/SearchGeneratorCommon/TagFilters',
      headers: headers
    }).done(function (data) {
      fuse = new Fuse(data, { keys: ['Name'] });
      $listTags.html(templateTags(data));
    });

    let templateIsScientist = Handlebars.compile(specialFilterTemplate);
    $listIsScientist.html(templateIsScientist({ Data: [{ "Value": null, "Name": "Använd ej" }, { "Value": true, "Name": "IsScientist=true" }, { "Value": false, "Name": "IsScientist=false" }], Name: 'isscientist' }));

    let templateIsLocal = Handlebars.compile(specialFilterTemplate);
    $listIsLocal.html(templateIsLocal({ Data: [{ "Value": null, "Name": "Använd ej" }, { "Value": true, "Name": "IsLocal=true" }, { "Value": false, "Name": "IsLocal=false" }], Name: 'islocal' }));

    let templateprojectPageDates = Handlebars.compile(specialFilterTemplate);
    $listProjectPageDates.html(templateprojectPageDates({ Data: [{ "Value": null, "Name": "Använd ej" }, { "Value": "endDateGtNow", "Name": "Pågående" }, { "Value": "dateIntervalPassed", "Name": "Avslutade" }], Name: 'projectpagedates' }));

    let templateIsDoctoralProject = Handlebars.compile(specialFilterTemplate);
    $listIsDoctoralProject.html(templateIsDoctoralProject({ Data: [{ "Value": null, "Name": "Använd ej" }, { "Value": true, "Name": "IsDoctoralProject=true" }, { "Value": false, "Name": "IsDoctoralProject=false" }], Name: 'isdoctoralproject' }));

    let templateEduLevel = Handlebars.compile(specialFilterTemplate);
    $listEduLevel.html(templateEduLevel({ Data: [{ "Value": null, "Name": "Använd ej" }, { "Value": "basic", "Name": "Grund" }, { "Value": "advanced", "Name": "Advancerad" }, { "Value": "pre", "Name": "Förutbildning" }], Name: 'edulevel' }));

    let templateEduTempo = Handlebars.compile(specialFilterTemplate);
    $listEduTempo.html(templateEduTempo({ Data: [{ "Value": null, "Name": "Använd ej" }, { "Value": true, "Name": "Heltid" }, { "Value": false, "Name": "Deltid" }], Name: 'edutempo' }));

    let templateCheckboxes = Handlebars.compile(checkboxListTemplate);
    $listEduLimitations.html(templateCheckboxes({ Data: [{ "Value": "IsEveningCourses", "Name": "Kvällskurser" }, { "Value": "IsDistanceEducation", "Name": "Distansutbildningar" }, { "Value": "IsSummerCourses", "Name": "Sommarkurser" }], Name: 'eduLimitations' }));

    // NOTE: Check if a current Button/searchConfig exists
    var $currentConfig = $(currentConfigButtonSelector, $searchConfigContainer);
    
    var currentConfigObject = searchConfigTemplate({ Id: currentConfigButtonDataId, Data: getCurrentValues(), IsRemovable: false  });
    if (!$currentConfig.length)
      $searchConfigContainer.append(currentConfigObject);
    else
      $currentConfig.replaceWith(currentConfigObject);

    $searchConfigApply.removeAttr('disabled');
  });

  $searchConfigApply.click(function() {
    var current = getCurrentValues();
    if (!current.site.value)
      return;

    $searchConfigContainer.append(searchConfigTemplate({ Id: '', Data: current, IsRemovable: true }));
    resetCurrentFilters();
  });

  $getResultButton.click(function (event) {
    event.preventDefault();

    var request = {
      'query': $searchQuery.val(),
      'sorting': $('#sorting-select', $listSorting).find("option:selected").val(),
      'maxCount': $('#max-count').val(),
      'items': []
    };
    var removeEmptyFilter = function (value) { return value !== null && value !== ''; };

    $('button', $searchConfigContainer).each(function (index) {
      var $this = $(this);
      var siteId = $this.attr('data-siteid');
      var language = $this.attr('data-language');
      var organisations = $this.attr('data-organisationValues').split(',').filter(removeEmptyFilter);
      var categories = $this.attr('data-categoryValues').split(',').filter(removeEmptyFilter);
      var tags = $this.attr('data-tagValues').split(',').filter(removeEmptyFilter);
      var isScientist = $this.attr('data-isScientist');
      var isLocal = $this.attr('data-isLocal');
      var projectPageDates = $this.attr('data-projectPageDates');
      var isDoctoralProject = $this.attr('data-isDoctoralProject');
      var eduLevel = $this.attr('data-eduLevel');
      var eduTempo = $this.attr('data-eduTempo');
      var eduLimitations = $this.attr('data-eduLimitations').split(',').filter(removeEmptyFilter);

      if (!siteId || !language)
        return; 

      request.items.push({
        'siteId': siteId,
        'language': language,
        'organisations': organisations,
        'categoriesTemp': categories,
        'tags': tags,
        'isScientist': isScientist,
        'isLocal': isLocal,
        'projectPageDates': projectPageDates,
        'isDoctoralProject': isDoctoralProject,
        'eduLevel': eduLevel,
        'eduTempo': eduTempo,
        'eduLimitations': eduLimitations
      });
    });

    // NOTE: The function needs a language to be able to pick the Block render, for now I pick the first language
    var siteLang = request.items[0].language;

    $queryString.val('');
    $searchResult.html(templateResultDefault({ StatusSearching: true }));
    

    $.ajax({
      type: "POST",
      url: '/api/SearchGeneratorCommon/Search',
      headers: {
        'X-Language': siteLang
      },
      data: request,
      success: function (response) {
        console.log('post success');
        let html = $.trim(response.ResultHtml);

        $queryString.val(response.QueryString);

        $searchResult.html(html ? html : templateResultDefault({ StatusNoHits: true }));
      }
    });
  });

  $searchTagsFilter.on('focus', function () {
    let value = $searchTagsFilter.val();

    if (value.length > 2)
      $listTagsFilter.removeClass(hiddenClassName).prop('aria-expanded', !$listTagsFilter.prop('aria-expanded'));
  }).on('keyup', function () {
    if (!fuse)
      return;

    let value = $searchTagsFilter.val(),
      closeDropdown = function (keepValue) {
        $listTagsFilter.addClass(hiddenClassName).prop('aria-expanded', false);

        if (!keepValue)
          $searchTagsFilter.val('');

        $document.off('click.tags');
      };

    if (value.length > 2) {
      $listTagsFilter.removeClass(hiddenClassName).prop('aria-expanded', true);
      let $parent = $listTagsFilter.parent();

      $document.on('click.tags', function (event) {
        let $target = $(event.target).parent();

        if (!$parent.is($target) && $parent.has($target).length === 0)
          closeDropdown();
      });

      $listTagsFilter.html(templateTagsFilter(fuse.search(value)));
    }
  });

  $searchConfigContainer.on('click', 'button', function () {
    event.preventDefault();
    var $this = $(this);
    if ($this.attr('data-id') === currentConfigButtonDataId)
      return;

    $this.remove();
    updateCurrentValues();
  });

  $listTagsFilter.on('click', 'button', function () {
    let $input = $listTags.find(`input[value="${$(this).attr('data-value')}"]`),
      wasChecked = $input.prop('checked');

    var checkedClass = 'tags-filter__list-item--checkbox-checked';
    var $thisTagsFilterItem = $(this).parent();
    wasChecked
      ? $thisTagsFilterItem.removeClass(checkedClass)
      : $thisTagsFilterItem.addClass(checkedClass);

    wasChecked
      ? $input.prop('checked', false).parent().parent().addClass(hiddenClassName)
      : $input.prop('checked', true).parent().parent().removeClass(hiddenClassName);

    updateCurrentValues();
  });

  $listTags.on('change', 'input', function () {

    var $listTagItem = $(this).parent().parent();
    $(this).prop('checked')
      ? $listTagItem.removeClass(hiddenClassName)
      : $listTagItem.addClass(hiddenClassName);
    updateCurrentValues();
  });

  $dropdownCheckbox.on('click', '.dropdown-checkbox__toggle', function () {
    let $this = $(this), $next = $this.next();
    $this.toggleClass(activeClassName);
    $next.toggleClass(hiddenClassName).prop('aria-expanded', !$next.prop('aria-expanded'));
  });

  $dropdownCheckbox.on('click', '.dropdown-checkbox__collapse', function () {
    let $this = $(this),
      activeClassName = 'dropdown-checkbox__collapse--active',
      $next = $this.next();

    $this.toggleClass(activeClassName);
    $next.toggleClass(hiddenClassName).prop('aria-expanded', !$next.prop('aria-expanded'));

    if ($this.hasClass(activeClassName)) {
      let $parent = $this.parent();

      $document.on('click.dropdown', function (event) {
        let $target = $(event.target).parent();

        if (!$parent.is($target) && $parent.has($target).length === 0) {
          $this.removeClass(activeClassName);
          $next.addClass(hiddenClassName).prop('aria-expanded', false);
        }
      });
    } else {
      $document.off('click.dropdown');
    }
  });

  $dropdownCheckbox.on('change', 'input', function () {
    let $this = $(this);

    let $li_parent = $this.parent().parent();
    $li_parent.toggleClass(checkedClassName);

    //update each span with text how many items are checked
    let $dropdown_container = $this.closest('.dropdown-checkbox');
    $dropdown_container.find('input').each(function () {
      let $this = $(this);
      $this.next().text(Math.max(0, $this.parent().parent().find('input:checked').length));
    });

    updateCurrentValues();
  }); 
  
  $listIsScientist.on('change', 'input', function () {
    updateCurrentValues();
  });

  $listIsLocal.on('change', 'input', function () {
    updateCurrentValues();
  });

  $listProjectPageDates.on('change', 'input', function () {
    updateCurrentValues();
  });

  $listIsDoctoralProject.on('change', 'input', function () {
    updateCurrentValues();
  });

  $listSorting.on('change', 'select', function () {
    updateCurrentValues();
  }); 

});
